import "./App.scss";
import * as React from "react";
import { useState, useCallback } from "react";
import { BrowserRouter as Router, Route, RouteComponentProps } from "react-router-dom";
import {Switch} from "react-router";
import { Home } from "./Assets/Scripts/Components/Home";
import { Login } from "./Assets/Scripts/Components/Login";
import { Navigation } from "./Assets/Scripts/Components/Navigation";
import { Auth } from "./Assets/Scripts/AuthContext";
import { Note } from "./Assets/Scripts/Components/CreateNote";
import { Token } from "./Assets/Scripts/Models/Token";
import { ForgotPwd } from "./Assets/Scripts/Components/ForgotPwd";
import { ResetPwd } from "./Assets/Scripts/Components/ResetPwd";
import { ProtectedRoute } from "./Assets/Scripts/Components/ProtectedRoute";
import { Admin } from "./Assets/Scripts/Components/Admin";
import { EditNote } from "./Assets/Scripts/Components/Edit";
import { Register } from "./Assets/Scripts/Components/Register";

const App: React.FunctionComponent = (): JSX.Element => {
    console.log("App");
    const [customAuth, setCustomAuth] = useState<Auth>({
        isLoggedIn: false,
    });

    const [noteToEditID, setNoteToEditID] = useState<string>("");

    const onNoteEdit = useCallback((id: string | undefined)=>{
        if(!id) return;
        setNoteToEditID(id);
        
    },[setNoteToEditID]);

    const onLogin = useCallback((token: Token) => {
        let newAuth: Auth = {
            isLoggedIn: true,
        };

        localStorage.setItem("token", token.token);
        localStorage.setItem("refreshToken", token.refreshToken);
        setCustomAuth(newAuth);
    }, []);

    const onLogout = useCallback(() => {
        let newAuth: Auth = {
            isLoggedIn: false,
        };

        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        setCustomAuth(newAuth);
    }, []);

    return (
        <div className="container">
            <Router>
                <Navigation
                    isLoggedIn={customAuth.isLoggedIn}
                    onLogout={onLogout}
                />

                <Switch>
                    <Route
                        exact
                        path="/login"
                        render={(props): JSX.Element => {
                            return <Login onLogin={onLogin} {...props} />;
                        }}
                    />
                     <Route
                        exact
                        path="/register"
                        render={(props): JSX.Element => {
                            return <Register {...props} />;
                        }}
                    />
                    <Route
                        exact
                        path="/forgotpwd"
                        render={(props): JSX.Element => {
                            return <ForgotPwd {...props} />;
                        }}
                    />

                    <Route
                        exact
                        path="/resetpwd"
                        render={(props): JSX.Element => <ResetPwd {...props} />}
                    />

                    <ProtectedRoute
                        isLoggedIn={customAuth.isLoggedIn}
                        exact
                        path="/"
                        component={(props: RouteComponentProps): JSX.Element => {
                            return <Home onLogout={onLogout} onNoteEdit={onNoteEdit} {...props} />;
                        }}
                    />
                    <ProtectedRoute
                        isLoggedIn={customAuth.isLoggedIn}
                        exact
                        path="/edit"
                        component={(props:RouteComponentProps): JSX.Element => {
                            return <EditNote {...props} noteToEditID={noteToEditID}/>;
                        }}
                    />
                    <ProtectedRoute
                        isLoggedIn={customAuth.isLoggedIn}
                        exact
                        path="/admin"
                        component={(): JSX.Element => {
                            return <Admin />;
                        }}
                    />

                    <ProtectedRoute
                        isLoggedIn={customAuth.isLoggedIn}
                        exact
                        path="/create"
                        component={(props): JSX.Element => {
                            return <Note {...props} />;
                        }}
                    />
                </Switch>
            </Router>
        </div>
    );
};

export default App;
